import React from "react";
import "./../styles/global.css";
import Navbar from "./../components/Navbar";
import IndexPage from "./index";
import AuthPage from "./auth";
import SettingsPage from "./settings";
import LegalPage from "./legal";
import AdminPage from "./admin";
import MyReservationsPage from "./my-reservations";
import PrivacyPolicy from "./privacy";
import { Switch, Route, Router } from "./../util/router";
import FirebaseActionPage from "./firebase-action";
import NotFoundPage from "./404";
import Footer from "./../components/Footer";
import { AuthProvider } from "./../util/auth";

function App(props) {
  return (
    <AuthProvider>
      <Router>
        <>
          <Navbar bgColor="bg-white" />

          <Switch>
            <Route exact path="/" component={IndexPage} />

            <Route exact path="/auth/:type" component={AuthPage} />

            <Route exact path="/settings/:section" component={SettingsPage} />

            <Route exact path="/legal/:section" component={LegalPage} />
            
            <Route exact path="/privacy" component={PrivacyPolicy} />

            <Route exact path="/admin" component={AdminPage} />

            <Route exact path="/my-reservations" component={MyReservationsPage} />

            <Route
              exact
              path="/firebase-action"
              component={FirebaseActionPage}
            />

            <Route component={NotFoundPage} />
          </Switch>

          <Footer
            size="md"
            bgColor="bg-white"
            textColor=""
            sticky={true}
          />
        </>
      </Router>
    </AuthProvider>
  );
}

export default App;
